import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { Controller, useFormContext } from 'react-hook-form';
import { Column, Divider, Row, TextField, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './ServicePriceEditorPopoverBundleContent.module.scss';
export const getServicePriceEditorPopoverBundleContentTID = ()=>getTestIds();
const ServicePriceEditorPopoverBundleContent = ()=>{
    const { t: texts } = useLocaleKeys('components.servicePriceEditorPopoverBundle');
    const { ServicePriceEditorPopoverBundleContentTID } = useMemo(()=>getServicePriceEditorPopoverBundleContentTID(), []);
    const { control, watch, setValue } = useFormContext();
    const includedServices = watch('bundle');
    if (!includedServices || includedServices.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs(Column, {
                gap: 16,
                testId: ServicePriceEditorPopoverBundleContentTID.Root(),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "normal",
                        children: texts.includedServices()
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        gap: 24,
                        children: includedServices.map((includedService, index)=>{
                            const serviceTemplateId = includedService.serviceTemplateId || '';
                            return /*#__PURE__*/ _jsxs(Row, {
                                gap: 16,
                                className: styles.includedServiceRow,
                                testId: ServicePriceEditorPopoverBundleContentTID.IncludedServiceRow(serviceTemplateId),
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph2",
                                        className: styles.includedServiceItem,
                                        testId: ServicePriceEditorPopoverBundleContentTID.IncludedServiceName(serviceTemplateId),
                                        children: includedService.name
                                    }),
                                    /*#__PURE__*/ _jsx(Controller, {
                                        control: control,
                                        name: "bundle.".concat(index, ".rate"),
                                        rules: {
                                            validate: (value)=>{
                                                if (!value) return texts.rateRequired();
                                                if (value.toNumber() < 0) return texts.rateNonNegative();
                                                return true;
                                            }
                                        },
                                        render: (param)=>{
                                            let { field, fieldState } = param;
                                            var _fieldState_error;
                                            return /*#__PURE__*/ _jsx(TextField, {
                                                collapseHelperText: false,
                                                testId: ServicePriceEditorPopoverBundleContentTID.IncludedServiceRateInput(serviceTemplateId),
                                                className: styles.includedServiceItem,
                                                isMoney: true,
                                                inputProps: {
                                                    min: 0
                                                },
                                                label: texts.priceLabel(),
                                                prefix: "$",
                                                value: field.value ? field.value.toNumber() : '',
                                                onChange: (e)=>{
                                                    const newValue = e.currentTarget.value;
                                                    const asNumber = +newValue;
                                                    if (asNumber < 0) return;
                                                    const decimalValue = new Decimal(newValue === '' ? 0 : asNumber);
                                                    field.onChange(decimalValue);
                                                    const totalRate = includedServices.reduce((acc, includedService)=>acc.plus(includedService.rate), new Decimal(0));
                                                    setValue('price', totalRate.toString());
                                                },
                                                error: !!fieldState.error,
                                                helperText: (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : _fieldState_error.message
                                            });
                                        }
                                    })
                                ]
                            }, serviceTemplateId);
                        })
                    })
                ]
            })
        ]
    });
};
export default ServicePriceEditorPopoverBundleContent;
